var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 424.8 392.8",
    style: {
      enableBackground: "new 0 0 424.8 392.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000143617378678780679050000001912444950712650638_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,293.6v54.1c0,24.9,20.2,45,45.1,45.1h334.7c24.9,0,45.1-20.2,45.1-45.1V45.1c0-24.9-20.2-45-45.1-45.1H45.1 C20.2,0,0,20.2,0,45.1l0,0v228.5 M379.8,20c13.8,0,25.1,11.2,25.1,25.1v267.8l-127.5-144c-3.7-4.1-10-4.5-14.1-0.9 c-0.3,0.3-0.6,0.6-0.9,0.9L194,246.1l-48.6-52.4c-3.8-4.1-10.1-4.3-14.1-0.5c-0.2,0.2-0.4,0.4-0.5,0.5L20,313.3V45.1 C20,31.2,31.2,20,45.1,20H379.8z M180.8,261.2l-49.9,56.4H43.3l94.8-102.3L180.8,261.2z M379.8,372.8H45.1 c-13.8,0-25.1-11.2-25.1-25.1v-10.2h216.9c5.5,0,10-4.5,10-10s-4.5-10-10-10h-79.3l112.3-127l112.3,127h-55c-5.5,0-10,4.5-10,10 s4.5,10,10,10h77.6v10.2C404.8,361.6,393.6,372.8,379.8,372.8L379.8,372.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,337.5c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10c0,0.7-0.1,1.3-0.2,2C291.1,334.2,287,337.5,282.3,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,160.2c-29.3,0-53-23.7-53-53s23.7-53,53-53s53,23.7,53,53C227.7,136.5,204,160.2,174.8,160.2z M174.8,74.2 c-18.2,0-33,14.8-33,33s14.8,33,33,33s33-14.8,33-33C207.7,88.9,193,74.2,174.8,74.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenders);
export default __webpack_public_path__ + "static/media/renders.53916b85b1aef3db22e4ebadf43ba690.svg";
export { ForwardRef as ReactComponent };